import React from 'react'

export const Nomatch = () => {
  return (
    <div><h1>Page Not Found .........</h1></div>
  )
}
